import { useRegisterSW } from 'virtual:pwa-register/react';
import { m } from '../paraglide/messages.js';
import { Toast, ToastAction, ToastRegion } from '../ui/Toast.tsx';

/**
 * Check for a new service worker hourly and whenever the app comes back to the foreground (iOS
 * pauses timers in the background, so the interval alone rarely fires); the user decides when to
 * reload.
 */
const UPDATE_CHECK_MS = 60 * 60 * 1000;
/** At most one check per this long from foreground returns. */
const FOREGROUND_CHECK_MS = 5 * 60 * 1000;

export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      if (!registration) return;
      let last = Date.now();
      const check = () => {
        last = Date.now();
        void registration.update().catch(() => undefined);
      };
      setInterval(check, UPDATE_CHECK_MS);
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible' && Date.now() - last > FOREGROUND_CHECK_MS) {
          check();
        }
      });
    },
  });

  if (!needRefresh) return null;
  return (
    <ToastRegion>
      <Toast
        duration={null}
        action={
          <>
            <ToastAction onClick={() => setNeedRefresh(false)}>{m.update_later()}</ToastAction>
            <ToastAction onClick={() => void updateServiceWorker(true)}>
              {m.update_reload()}
            </ToastAction>
          </>
        }
      >
        <strong>{m.update_title()}</strong> {m.update_detail()}
      </Toast>
    </ToastRegion>
  );
}
